import React from 'react';

const LockIcon = ({ width = 21, height = 21, ...rest }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.0228 10.4974C17.0228 9.57823 16.2753 8.83073 15.3561 8.83073H14.5228V6.33073C14.5228 4.03323 12.6536 2.16406 10.3561 2.16406C8.05862 2.16406 6.18945 4.03323 6.18945 6.33073V8.83073H5.35612C4.43695 8.83073 3.68945 9.57823 3.68945 10.4974V17.1641C3.68945 18.0832 4.43695 18.8307 5.35612 18.8307H15.3561C16.2753 18.8307 17.0228 18.0832 17.0228 17.1641V10.4974ZM7.85612 6.33073C7.85612 4.9524 8.97779 3.83073 10.3561 3.83073C11.7345 3.83073 12.8561 4.9524 12.8561 6.33073V8.83073H7.85612V6.33073Z"
        fill="#616161"
      />
    </svg>
  );
};

export default LockIcon;
